<template>
  <div :class="{ 'has-logo': showLogo, 'studyMenu': menuTypeCss === 2}">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="true"
        :unique-opened="true"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in datas"
          :key="route.path"
          :item="route"
          :base-path="route.path"
          v-if="menuTypeCss == 2 || sidebarArr.indexOf(route.path) > -1"
        />
        <div class="left_side_btm">
          <div
            class="menu-des el-menu-item submenu-title-noDropdown menu_type_name"
          >
            系统
          </div>
          <sidebar-item
            v-for="route in datas2"
            :key="route.path"
            :item="route"
            :base-path="route.path"
            v-if="menuTypeCss == 2 ||  sidebarArr.indexOf(route.path) > -1"
          />
          <!-- <sidebar-item
            v-for="route in sroutes"
            :key="route.path"
            :item="route"
            :base-path="route.path"
          /> -->
          <div
            class="menu-btn el-menu-item submenu-title-noDropdown menu_logout"
            @click="logout"
          >
            登出系统
          </div>
        </div>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "@/styles/variables.scss";
import API from "../../../api/api_user";
export default {
  components: { SidebarItem, Logo },
  computed: {
    sidebar() {
      return this.$store.state.sidebar;
    },
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      //this.$store.state.settings.sidebarLogo
      return false;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return true || !this.sidebar.opened;
    },
    datascomputed() {
      // 计算系统之上的菜单
    },
    datas2computed() {
      // 计算系统的菜单
    }
  },
  data() {
    return {
      sroutes: [],
      sidebarArr: [],
      datas: {
        children: [],
        code: null,
        component: null,
        iconCls: "iconfont  dibutubiao_shouye",
        id: 900,
        leaf: false,
        menuShow: true,
        menuType: 0,
        name: "首页",
        parentId: 0,
        path: "/dashboard?clearTabNav=true",
        redirect: null,
        menuTypeCss: 1
      },
      datas2: {}
    };
  },
  created() {
    this.init();
  },
  mounted() {
    // this.init()
  },
  methods: {
    init() {
      API.router().then(result => {
        this.sroutes = result.router;
        // 需要进行转义
        // 按照最新的菜单进行处理
        // todo 权限是如何处理的？
        // 1.根据router 判断是否应该显示菜单
        // 2.根据router 判断
        this.$store.state.menus = result.router;
        let menusPath = []
        this.sidebarArr = ["/course/mall",'/recording','/learnCard']
         let reduceMap =  {
            "/base": "/questionBank",
            "/training": "/user",
            "/file": "/file",
            "/statistical/query": "/statistical",
            "/log": "/system",
            "/warning": "/warning",
            "/related": "/related",
            "/running/index": "/running/index",
            "/sys": "/management"
        }
       let fn = (item, dept) => {
          if(dept == 0){
            this.sidebarArr.push(reduceMap[item.path])
          }
          if(item.path){
            menusPath.push(item.path)
          }
          if (item.children && item.children.length > 0) {
            item.children.forEach(item => fn(item, dept + 1))
          }
        }
        result.router.forEach(item => fn(item, 0))
        this.$store.state.menusPath = menusPath
        console.log(menusPath, this.sidebarArr)
        // 判断是否学员端：
        console.log(result)
        if (result.router && result.router[0] && result.router[0].name == "学员端")  {
          this.initStu()
          this.menuTypeCss = 2;
        } else {
          this.initAdmin();
          this.menuTypeCss = 1;
        }
      });
    },
    initStu() {
      localStorage.setItem('isMainLevel', 0)
      this.datas = [
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_faxian",
          id: 900,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "发现课程",
          parentId: 0,
          path: "/course/mall",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_peixun",
          id: 901,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "我的培训",
          parentId: 0,
          path: "/student/myTrain",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_kaoshi",
          id: 902,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "我的考试",
          parentId: 0,
          path: "/student/myExam",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_tiku",
          id: 903,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "我的题库",
          parentId: 0,
          path: "/sheet",
          redirect: null
        },
      ];

      this.datas2 = [
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_fankui",
          id: 905,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "反馈与投诉",
          parentId: 0,
          path: "/individual/center/feedback",
          redirect: null
        },
      ];
    },
    initAdmin() {
      this.datas = [
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_shouye",
          id: 900,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "系统首页",
          parentId: 0,
          path: "/course/mall",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_kecheng",
          id: 901,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "课程资源管理",
          parentId: 0,
          path: "/questionBank",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_xueyuan",
          id: 902,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "学员管理",
          parentId: 0,
          path: "/user",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_tongji",
          id: 903,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "统计查询",
          parentId: 0,
          path: "/statistical",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_chaozuo",
          id: 904,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "操作日志",
          parentId: 0,
          path: "/system",
          redirect: null
        }
      ];

      this.datas2 = [
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_fankui",
          id: 905,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "反馈与投诉",
          parentId: 0,
          path: "/related",
          redirect: null
        },
        {
          children: [],
          code: null,
          component: null,
          iconCls: "iconfont dibutubiao_shouye menu_xitong",
          id: 906,
          leaf: false,
          menuShow: true,
          menuType: 0,
          name: "系统管理",
          parentId: 0,
          path: "/management",
          redirect: null
        }
      ];
      let userinfoStr = localStorage.getItem("userinfo");
	    let userinfo=JSON.parse(userinfoStr);
      // 放开机构用户数
      this.$store.state.menusPath.push('/admin/org');
      if(userinfo.orgId && userinfo.orgId.length == 0) {
        this.$store.state.menusPath.push('/admin/org')
        localStorage.setItem('isMainLevel', 1)
        // this.datas.push({
        //   children: [],
        //   code: null,
        //   component: null,
        //   iconCls: "iconfont dibutubiao_shouye menu_chaozuo",
        //   id: 904,
        //   leaf: false,
        //   menuShow: true,
        //   menuType: 0,
        //   name: "补录",
        //   parentId: 0,
        //   path: "/recording",
        //   redirect: null
        // })
        // this.datas.push({
        //   children: [],
        //   code: null,
        //   component: null,
        //   iconCls: "iconfont dibutubiao_shouye menu_chaozuo",
        //   id: 904,
        //   leaf: false,
        //   menuShow: true,
        //   menuType: 0,
        //   name: "学习卡",
        //   parentId: 0,
        //   path: "/learnCard",
        //   redirect: null
        // })
      } else {
        localStorage.setItem('isMainLevel', 2) 
        // if(this.sidebarArr.length > 1) {
        //   this.datas.splice(0,1)
        // } 
      }
      this.$store.state.menusPath.push('/trainingManagement/pushList2')
      this.$store.state.menusPath.push('/admin/params')
    },
    logout() {
      let that = this;
      this.$confirm("确认退出吗?", "提示", {
        confirmButtonClass: "el-button--warning"
      })
        .then(() => {
          that.loading = true;
          let token = window.localStorage.getItem("access-token");
          API.logout({
            token: token
          }).then(function(res) {
            window.localStorage.removeItem("access-token");
            window.localStorage.removeItem("menus");
            window.localStorage.clear();
            window.sessionStorage.clear();
            window.localStorage.clear();
            that.$router.push("/login"); //跳转 回登陆页面
            window.location.reload()
            // window.location.href = '/login'
          });
        })
        .catch(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/layout/components/Sidebar/index.vue